import 'underscore';
import config from 'tradera-apps/syi/script/app_react/services/config';

var initialState = {
    commissionProcent: '10',
    discountFactor: null,
    campaignCommissionProcent: null,
    minCommissionCost: config.commissionMinimum,
    maxCommissionCost: config.commissionCap,
    isVariableCommission: false,
    chosenExtraFeatures: [],
    hasChosenExtraFeatures: false,
    isUnsoldFeeFree: false,
    isCategoryWithNoCommissionCap: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'SET_COMMISSION_PROCENT': {
            state = _.assign({}, state, {
                commissionProcent: action.commissionProcent
            });
            break;
        }

        case 'SET_DISCOUNT_FACTOR': {
            state = _.assign({}, state, {
                discountFactor: action.discountFactor
            });
            break;
        }

        case 'RESET_DISCOUNT_FACTOR': {
            state = _.assign({}, state, {
                discountFactor: initialState.discountFactor
            });
            break;
        }

        case 'SET_CAMPAIGN_COMMISSION_PROCENT': {
            state = _.assign({}, state, {
                campaignCommissionProcent: action.campaignCommissionProcent
            });
            break;
        }

        case 'RESET_CAMPAIGN_COMMISSION_PROCENT': {
            state = _.assign({}, state, {
                campaignCommissionProcent:
                    initialState.campaignCommissionProcent
            });
            break;
        }

        case 'SET_MAX_COMMISSION_COST': {
            state = _.assign({}, state, {
                maxCommissionCost: action.payload.maxCommissionCost,
                isCategoryWithNoCommissionCap:
                    action.payload.isCategoryWithNoCommissionCap
            });
            break;
        }

        case 'SET_MIN_COMMISSION_COST': {
            state = _.assign({}, state, {
                minCommissionCost: action.payload.text
            });
            break;
        }

        case 'SET_IS_VARIABLE_COMMISSION': {
            state = _.assign({}, state, {
                isVariableCommission: action.payload
            });
            break;
        }

        case 'SET_UNSOLD_FEE_FREE_FOR_CAMPAIGN': {
            state = _.assign({}, state, { isUnsoldFeeFree: true });
            break;
        }

        case 'UNSET_UNSOLD_FEE_FREE_FOR_CAMPAIGN': {
            state = _.assign({}, state, { isUnsoldFeeFree: false });
            break;
        }

        case 'SET_CHOSEN_EXTRA_FEATURES': {
            var hasChosenExtraFeatures =
                action.payload && action.payload.length;
            state = _.assign({}, state, {
                chosenExtraFeatures: action.payload,
                hasChosenExtraFeatures
            });

            break;
        }
    }

    return state;
};
